import { render, staticRenderFns } from "./RentabilidadSocios.vue?vue&type=template&id=11cf4e4d&"
import script from "./RentabilidadSocios.vue?vue&type=script&lang=js&"
export * from "./RentabilidadSocios.vue?vue&type=script&lang=js&"
import style0 from "./RentabilidadSocios.vue?vue&type=style&index=0&id=11cf4e4d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports